"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover_1 = require("../components/MobilePopover");
const DevicePredicateModal = ({ activePopover, children, closePopoverModalForm, context, device, deviceSchema, lists, deviceListEnabledKeyPaths, id, isPopoverModalFormOpen, selectedPredicate, onChange, updateActivePopover, uploadDeviceList, }) => {
    const POPOVER_NAME = `device-predicate-builder-${context}-${id}`;
    const closePopover = () => {
        closePopoverModalForm();
        window.setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
    };
    const renderPredicateBuilder = () => (React.createElement(src_1.PredicateBuilder, { attributeType: "Device", schemas: deviceSchema, device: device, onCancel: closePopover, popOverTargetParent: "root", listEnabledKeyPaths: deviceListEnabledKeyPaths, lists: lists, onListUpload: uploadDeviceList, onAdd: (predicate) => {
            onChange(predicate);
            updateActivePopover('');
        }, selectedPredicate: selectedPredicate }));
    if (device === 'Mobile') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null, children),
            activePopover === POPOVER_NAME &&
                ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, hideNavBar: true }, renderPredicateBuilder()), document.getElementById('mainModalLeft'))));
    }
    return (React.createElement(src_1.PopoverContainer, { id: POPOVER_NAME, onClick: () => {
            if (activePopover === POPOVER_NAME) {
                closePopover();
            }
        }, popoverProps: { placement: 'right', device }, showPopover: activePopover === POPOVER_NAME, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft' },
        children,
        renderPredicateBuilder()));
};
const mapStateToProps = (state) => {
    const settings = reducers_1.getSettings(state);
    return {
        activePopover: reducers_1.getActivePopover(state),
        isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
        deviceSchema: reducers_1.getDeviceSchema(state),
        lists: reducers_1.getDeviceLists(state),
        deviceListEnabledKeyPaths: settings.keyPaths,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
        updateActivePopover: (field) => dispatch(actions_1.updateActivePopover(field)),
        uploadDeviceList: (file) => dispatch(actions_1.uploadDeviceList(file)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DevicePredicateModal);
